import { fetchData } from "./fetch";

export const getPerformance = () => fetchData('GET', '/performance');

export const getCampaignPerformance = (id) => fetchData('GET', `/performance/${id}`);
